<template>
  <div class="accordion global__fade-in-up" :id="id">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'accordion-1',
    },
  },
  mounted() {
    this.$el
      .querySelectorAll('.accordion-item button')
      .forEach(function(button) {
        button.addEventListener('click', function() {
          var active = this.classList.contains('active')
          this.setAttribute('aria-expanded', !active)
          this.nextElementSibling.setAttribute('aria-hidden', active)
          this.classList.toggle('active')
        })
      })
  },
}
</script>
